/**
 * @generated SignedSource<<2c9f14b311c924b1c1dbdf44389b9bdb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleRecirculationWidgetArticle$data = {
  readonly sponsorType: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"furtherReadingWidgetArticle" | "mostReadWidgetArticle" | "topicYouMayLikeWidgetArticle">;
  readonly " $fragmentType": "articleRecirculationWidgetArticle";
};
export type articleRecirculationWidgetArticle$key = {
  readonly " $data"?: articleRecirculationWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleRecirculationWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleRecirculationWidgetArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sponsorType",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "furtherReadingWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "mostReadWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topicYouMayLikeWidgetArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "4c0ac256fddc379394e54088c1f9d213";

export default node;
